import { Box, Flex, Icon, Text } from "@nulogy/components";
import HalfField from "components/common/HalfField";
import Section from "components/common/Section";
import { formatDateTime, formatDuration } from "components/helpers/format";
import DowntimeBlock from "domain/DowntimeBlock";
import React from "react";

const Label = ({ children }) => (
  <Text fontSize="small" fontWeight="bold">
    {children}
  </Text>
);

export default function ReadOnlyDowntimeBlock({ blockData }) {
  const {
    block: { line, lockedOnSchedule, startsAt, endsAt, overlappingPlannedBreaks },
  } = blockData;

  const reasonDescription = DowntimeBlock.reasonDescription(blockData.block);

  return (
    <Section
      controls={
        <Box marginBottom="x2">
          {lockedOnSchedule && <Icon color="darkBlue" icon="lock" mr="x1" pt="4px" size="28px" />}
        </Box>
      }
      mb={0}
      title="Scheduling details"
    >
      <Box marginBottom="x2">
        <Label>Reason</Label>
        <div style={{ paddingTop: 5 }}>{reasonDescription}</div>
      </Box>
      <Box marginBottom="x2">
        <Label>Line</Label>
        <div style={{ paddingTop: 5 }}>{line.name}</div>
      </Box>
      <Box marginBottom="x2">
        <Flex className="customDatePicker">
          <Box marginRight="x3" width={1 / 2}>
            <Label>Starts</Label>
            <div style={{ paddingTop: 5 }}>{formatDateTime(startsAt)}</div>
          </Box>
          <Box marginLeft="x3" width={1 / 2}>
            <Label>Ends</Label>
            <div style={{ paddingTop: 5 }}>{formatDateTime(endsAt)}</div>
          </Box>
        </Flex>
      </Box>
      {overlappingPlannedBreaks.length > 0 && (
        <HalfField labelText="Planned breaks">
          {overlappingPlannedBreaks.map(({ plannedBreakName, duration }) => (
            <Text key={plannedBreakName}>{`${plannedBreakName}: ${formatDuration(duration)}`}</Text>
          ))}
        </HalfField>
      )}
    </Section>
  );
}
